import uniq from 'lodash.uniq'

import { tabs } from 'modules/SlotsRoot/data/tabs'
import { Providers } from 'modules/SlotsRoot/types/configuration'
import { ISlotDTO } from 'modules/SlotsRoot/types/interfaces/Slots/GameCatalog'

import { uniqGameId } from './uniqGameId'

const excludeLiveSlotsToCasino = ['1301']

export const softgamingFilterProviders = [
  'evosw',
  'spribe',
  'betsolutions',
  // 'pragmatic',
  'boongo',
  // 'pragmaticplay',
  // 'pragmaticplaylive',
  'upgaming',
  'pgsoft',
  'aesexybaccarat',
  'vivogaming',
  'betsoft',
  'spinomenal',
  'xprogaming',
  'bgaming',
  'spadegaming',
  'evoplaygames',
  // 'habanero',
  'galaxsys',
  'yggdrasil',
  'smartsoft',
]

export const keltGamesBlackListProviders = [
  'pragmatic',
  'pragmaticplay',
  'pragmaticplaylive',
  'pgsoft',
  'spribe',
  'evoplay',
]

export const DIGITAIN_PROVIDERS_WHITE_LIST = [
  'Digitain Virtual Sport',
  'BetSoft',
  // 'Tom Horn',
  // 'Galaxsys',
  'Fugaso',
  'EurasianGaming',
  'RubyPlay',
  'Onlyplay',
  '7Mojos',
  'TVBet',
  'ImagineLive',
  'Espresso',
]

export const renameDigitainProvider = (prov: string) => {
  const renamedDigiProvider = prov?.toLowerCase() || ''
  return providerReplacingNames[renamedDigiProvider] || renamedDigiProvider
}

export const getSoftgamingFilterProviders = () => softgamingFilterProviders.join(',')

export const providerReplacingNames: { [key: string]: string } = {
  evosw: 'evolution',
  pragmatic: 'pragmaticplay',
  xprogaming: 'xpg',
  egtinteractive: 'amusnet',
  egtdigital: 'egt',
  evoplaygames: 'evoplay',
  tomhorngaming: 'tom horn',
}

export function getGameCatalogTab(slotId: string, dropAndWins?: boolean): string[] {
  const additionalTabs: string[] = dropAndWins ? ['Drops & Wins'] : []

  const trueTab = Object.keys(tabs).reduce(
    (acc: string[], tab: string) => (!tabs[tab].includes(slotId) ? acc : [...acc, tab]),
    [],
  )
  return uniq([...additionalTabs, ...trueTab])
}

export const providerLiveReplacingNames: { [key: string]: string } = {
  pragmatic: 'pragmaticplaylive',
  egtinteractive: 'amusnetlive',
}

export const blackListGames: string[] = [
  // uniqGameId(Providers.SOFTGAMING, 'spribe', 'aviator'),
  uniqGameId(Providers.SOFTGAMING, 'betsolutions', '5004'),
]

export const getSlotProviderName = (slot: ISlotDTO): string => {
  if (
    (slot.integration === Providers.DIRECT_PRAGMATIC || slot.integration === Providers.KELT_GAMES) &&
    slot.producer === 'pragmatic'
  ) {
    return slot.game_type && slot.game_type.includes('live-casino') && !excludeLiveSlotsToCasino.includes(slot.game_id)
      ? providerLiveReplacingNames[slot.producer]
      : providerReplacingNames[slot.producer]
  }

  if (slot.integration === Providers.DIGITAIN) {
    return renameDigitainProvider(slot.provider)
  }

  if (slot.integration === '028142ca' && slot.producer === 'egtinteractive') {
    if (slot.game_type && slot.game_type.includes('live-casino')) {
      return providerLiveReplacingNames[slot.producer]
    }
  }

  return providerReplacingNames[slot.producer] || slot.producer
}

export const getIsFreeSpinAvailable = (provider: string, isGameHasFreeSpins: boolean, isHide?: boolean) =>
  isGameHasFreeSpins || (provider === 'pragmaticplay' && isGameHasFreeSpins && isHide)

export const providersWhiteList = [
  ...softgamingFilterProviders,
  ...Object.values(providerReplacingNames),
  ...Object.values(providerLiveReplacingNames),
]

const replaceGameTypeName = {
  slots: 'casino',
  'live-casino': 'live-casino',
}

export const getGameType = (item: ISlotDTO) => {
  const gameTypes = item.game_type || []

  const replacedGameType = gameTypes.includes('live-casino')
    ? replaceGameTypeName['live-casino']
    : replaceGameTypeName.slots

  if (item.integration === Providers.DIGITAIN) {
    if (item.provider === 'Digitain Virtual Sport') {
      return { gameType: 'virtual' }
    }
    return { gameType: replacedGameType }
  }

  if (item.provider === 'egtinteractive') {
    return { gameType: replacedGameType }
  }

  return {}
}
